import { selectSessionCredentials } from "store/session/selectors"
import { useAppSelector } from "./storeHooks"
import { Role } from "types/Role";

export const useRoles = () => {
  const credentials = useAppSelector(selectSessionCredentials);
  const verifyRole = (myRole: string) => !!credentials.roles.some((role : any) => role.name === myRole);
  return {
    isAdmin: verifyRole(Role.Admin),
  }
}